import { Breadcrumb } from "antd";
import React from "react";

export const BreadCrumbs = (props) => {
  const { onBreadClick, headers, breadProps } = props;
  return (
    <Breadcrumb className="page-header" {...breadProps}>
      {headers.map((header) => (
        <Breadcrumb.Item key={header.title}>
          <a
            onClick={
              onBreadClick
                ? onBreadClick(header.onClick)
                : header.onClick || null
            }
          >
            {header.title}
          </a>
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};
